<template>
  <div class="sub-page">
    <van-nav-bar :title="$t('setting.modify_real_name')"  class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#c9a84c" size="20" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="card">
      <van-field v-model="name"  :label="$t('setting.name')" :placeholder="$t('setting.name_place')" />
    </div>
    <p class="tip">{{$t("setting.name_tip")}}</p>
    <div class="sub-btn" @click="save()">
      {{ $t('q59') }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name:"",
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    save(){
      if(this.userInfo.name){
        this.$toast(this.$t("setting.repect"));
        return true;
      }
      if(this.name === "" || this.name === null || this.name === undefined){
        this.$toast.fail(this.$t("setting.name_place"));
        return false;
      }
      this.$http({
        method: 'get',
        data:{name:this.name},
        url: 'user_set_name'
      }).then(res=>{
        if(res.code === 200){
          this.$toast.success(res.msg || this.$t("setting.ok"));
          this.$router.replace({ path: "/Infomation" });
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
.sub-page{
  min-height: 100vh;
  background: #000000;
  padding-bottom: 40px;
}
.card{
  background: #141414;
  border-radius: 16px;
  margin: 24px;
  overflow: hidden;
  /deep/ .van-cell{
    padding: 28px;
    font-size: 28px;
  }
  /deep/ .van-field__label{
    color: #666;
  }
}
.tip{
  color: #c9a84c;
  padding: 0 36px;
  font-size: 26px;
  margin: 0;
}
.sub-btn{
  background: #c9a84c;
  margin: 40px 24px 0;
  border-radius: 44px;
  color: #000;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  padding: 24px 0;
}
</style>
